module.exports = __webpack_public_path__ + "static/media/f_hairstyle_straight_long_back_vector.c817dd1c.svg";